(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["bud-designer/react-canvas-core"] = factory();
	else
		root["bud-designer/react-canvas-core"] = factory();
})(self, () => {
return 